module.exports = __webpack_public_path__ + "tinymce-small.a2a1f732cc34764c684e.svg";


//////////////////
// WEBPACK FOOTER
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/assets/skins/lightgray/fonts/tinymce-small.svg
// module id = ../../../../../src/assets/skins/lightgray/fonts/tinymce-small.svg
// module chunks = 3